export var ContextResponse;
(function (ContextResponse) {
    ContextResponse.EnabledFeaturesEnum = {
        HaveYouForgotten: 'HaveYouForgotten',
        EnhancedFiltersOnboarding: 'EnhancedFiltersOnboarding',
        CampaignHeader: 'CampaignHeader',
        ChangeOrder: 'ChangeOrder',
        ChangeOrderOnboardingModal: 'ChangeOrderOnboardingModal',
        PurchasingUnitsOnboardingModal: 'PurchasingUnitsOnboardingModal',
        ProjectShore: 'ProjectShore',
        XmasCampaign: 'XmasCampaign',
        RecipesAddToTrolley: 'RecipesAddToTrolley',
        InfiniteScrollingProductSearch: 'InfiniteScrollingProductSearch',
        PiesEnableEachUnitForKgProducts: 'PiesEnableEachUnitForKgProducts',
        ManagedServiceBar: 'ManagedServiceBar',
        ProductStraps: 'ProductStraps',
        EnableLockerPickup: 'EnableLockerPickup',
        SavedRecipes: 'SavedRecipes',
        DeliverySubscriptionSignUp: 'DeliverySubscriptionSignUp',
        ExpressPickup: 'ExpressPickup',
        ExpressDelivery: 'ExpressDelivery',
        OrderConfirmation: 'OrderConfirmation',
        LazyLoadProductStampImages: 'LazyLoadProductStampImages',
        FirstTimeShopper: 'FirstTimeShopper',
        CountryOfOriginInAccordion: 'CountryOfOriginInAccordion',
        ScanToTrolley: 'ScanToTrolley',
        NewDeliverySubscriptionPage: 'NewDeliverySubscriptionPage',
        ChangeDeliverySubscriptionPlan: 'ChangeDeliverySubscriptionPlan',
        CancelOrder: 'CancelOrder',
        WPayFramesSDK: 'WPayFramesSDK',
        ForgotPassword: 'ForgotPassword',
        SimplifiedLogin: 'SimplifiedLogin',
        JQueryDeprecationLogging: 'JQueryDeprecationLogging',
        PaperPackingSlipPreference: 'PaperPackingSlipPreference',
        Optimizely: 'Optimizely',
        OptimizelyWeb: 'OptimizelyWeb',
        DeliverySaverBannerOnTrolleyPage: 'DeliverySaverBannerOnTrolleyPage',
        CustomerSelfService: 'CustomerSelfService',
        EnableDeliverySaverRetryPayment: 'EnableDeliverySaverRetryPayment',
        MerchantHostedLocalStorefront: 'MerchantHostedLocalStorefront',
        RecipesInApp: 'RecipesInApp',
        RecipeCategorySeo: 'RecipeCategorySeo',
        SwitchToggleToShowInStockItemsOnly: 'SwitchToggleToShowInStockItemsOnly',
        EnableBoostsLandingPage: 'EnableBoostsLandingPage',
        Brickify: 'Brickify',
        MealPlanning: 'MealPlanning',
        ChangeOrderIndicateChangedPriceInProductList: 'ChangeOrderIndicateChangedPriceInProductList',
        UseSSU: 'UseSSU',
        ChangeOrderPromptHomepage: 'ChangeOrderPromptHomepage',
        AccountMenuMyOrdersLink: 'AccountMenuMyOrdersLink',
        ChangeOrderChangedPriceTutorial: 'ChangeOrderChangedPriceTutorial',
        ChristmasWapple: 'ChristmasWapple',
        ChangeOrderAccountMenu: 'ChangeOrderAccountMenu',
        OnlineSamplePastOrders: 'OnlineSamplePastOrders',
        HideSwitchToggleForOOS: 'HideSwitchToggleForOOS',
        OnlineSamplesCheckoutJourney: 'OnlineSamplesCheckoutJourney',
        OnlineSampleOrderConfirmation: 'OnlineSampleOrderConfirmation',
        DebugDigitalPayIFrame: 'DebugDigitalPayIFrame',
        StickyCTAReviewOrder: 'StickyCTAReviewOrder',
        OnlineSampleRemarketing: 'OnlineSampleRemarketing',
        SameDayDelivery: 'SameDayDelivery',
        GreatToLowPrice: 'GreatToLowPrice',
        ViewOrderConfirmationLinkOnMyOrders: 'ViewOrderConfirmationLinkOnMyOrders',
        PickupSlotOfferings: 'PickupSlotOfferings',
        EnableEDR: 'EnableEDR',
        EnableHaveYouForgottenGATracking: 'EnableHaveYouForgottenGATracking',
        ShowDiscountPercentage: 'ShowDiscountPercentage',
        MobileSSU: 'MobileSSU',
        EnableCartologyGA4EventTracking: 'EnableCartologyGA4EventTracking',
        ExpressPickupSlotOfferings: 'ExpressPickupSlotOfferings',
        ChangeOrderChangedPriceTutorialMobileWeb: 'ChangeOrderChangedPriceTutorialMobileWeb',
        CheckSSU: 'CheckSSU',
        RebrandInHeaderAndFooter: 'RebrandInHeaderAndFooter',
        EnableOrderChangeOnlineSamples: 'EnableOrderChangeOnlineSamples',
        EnableDeviceFingerprinting: 'EnableDeviceFingerprinting',
        CountryOfOriginFromPAS: 'CountryOfOriginFromPAS',
        HaystackEDRChanges: 'HaystackEDRChanges',
        EnableFeatureProductStamp: 'EnableFeatureProductStamp',
        LowPriceProductStrap: 'LowPriceProductStrap',
        ProductPricingFromTraderMongoDB: 'ProductPricingFromTraderMongoDB',
        NewUserRegisterationFlow: 'NewUserRegisterationFlow',
        HomePageHeroCarousel: 'HomePageHeroCarousel',
        NewBrowseMenuLinks: 'NewBrowseMenuLinks',
        EnableOlsEnhancementsInPastOrder: 'EnableOlsEnhancementsInPastOrder',
        EnableOlsOfferMessaging: 'EnableOlsOfferMessaging',
        NewRecipeABTest: 'NewRecipeABTest',
        EnableBrandSuggectionBugfix: 'EnableBrandSuggectionBugfix',
        ReloadDataInFavouritesAndLists: 'ReloadDataInFavouritesAndLists',
        DisplayNewLozenge: 'DisplayNewLozenge',
        BoostShopRange: 'BoostShopRange',
        EnableFeatureRecipeStamp: 'EnableFeatureRecipeStamp',
        EnableAislePromoTiles: 'EnableAislePromoTiles',
        DisplayNewOlsAndYouMightLikeCarousels: 'DisplayNewOlsAndYouMightLikeCarousels',
        EnablePDPNewDesign: 'EnablePDPNewDesign',
        EnableOnlineSamplesRemarketingLog: 'EnableOnlineSamplesRemarketingLog',
        PickupSlotOfferingsCustomerETA: 'PickupSlotOfferingsCustomerETA',
        EnableMultiBuyGreatPriceTagMissingFix: 'EnableMultiBuyGreatPriceTagMissingFix',
        EnableWPay: 'EnableWPay',
        EnablePDPTabOrder: 'EnablePDPTabOrder',
        EnableCUPUIAdjustments: 'EnableCUPUIAdjustments',
        FirstTimeShopperImprovementsEnabled: 'FirstTimeShopperImprovementsEnabled',
        EnablePasCupCalculations: 'EnablePasCupCalculations',
        EnablePasMissingPrice: 'EnablePasMissingPrice',
        EnableMyFavouritesPastOrdersProductCarousel: 'EnableMyFavouritesPastOrdersProductCarousel',
        EnableCallingCitrusWithFetch: 'EnableCallingCitrusWithFetch',
        EnablePasOnlineOnlyTag: 'EnablePasOnlineOnlyTag',
        EnableDiscardPasPriceIfNoPriceInTrader: 'EnableDiscardPasPriceIfNoPriceInTrader',
        EnableHYFTopPicksTile: 'EnableHYFTopPicksTile',
        EnableClickToPay: 'EnableClickToPay',
        EnablePersonalisedMyFavCarousels: 'EnablePersonalisedMyFavCarousels',
        EnableRebrandToDeliveryNow: 'EnableRebrandToDeliveryNow',
        EnableIncrementalChangeOrder: 'EnableIncrementalChangeOrder',
        EnableEdrRewardMessages: 'EnableEdrRewardMessages',
        EnableEdrAves: 'EnableEdrAves',
        EnableHWWBarInHeader: 'EnableHWWBarInHeader',
        EnableAtpSignInContent: 'EnableAtpSignInContent',
        PasClearanceTag: 'PasClearanceTag',
        EnableGA4AddToCartItemVariant: 'EnableGA4AddToCartItemVariant',
        RedirectValidation: 'RedirectValidation',
        CartologyGAMSessionGroup: 'CartologyGAMSessionGroup',
        EnableApplePay: 'EnableApplePay',
        EnableGA4HomePageBugFix: 'EnableGA4HomePageBugFix',
        EnableGooglePay: 'EnableGooglePay',
        UseItemsLimitFromFulfilmentSlots: 'UseItemsLimitFromFulfilmentSlots',
        EnableDTBOptInOutWithGroupedOfferrings: 'EnableDTBOptInOutWithGroupedOfferrings',
        EnableDualOfferings: 'EnableDualOfferings',
        HideSpecialTag: 'HideSpecialTag',
        EnableWPayDeliverySaver: 'EnableWPayDeliverySaver',
        EnableFlexibleDelivery: 'EnableFlexibleDelivery',
        EnableCheckChangeOrderOnLoad: 'EnableCheckChangeOrderOnLoad',
        IsAgeRestrictedPopupEnabled: 'IsAgeRestrictedPopupEnabled',
        EnableFlexibleDeliveryV2: 'EnableFlexibleDeliveryV2',
        EnableTestingOfChangeOrderAutomationError: 'EnableTestingOfChangeOrderAutomationError',
        EnableConsistencyAndPriorityForBanners: 'EnableConsistencyAndPriorityForBanners',
        EnableMemberPriceWithMultibuys: 'EnableMemberPriceWithMultibuys',
        EnableHandlingOfChangeOrderAutomationError: 'EnableHandlingOfChangeOrderAutomationError',
        EnableMultibuyLiquorThresholdCalculation: 'EnableMultibuyLiquorThresholdCalculation',
        EnableNoSaveSpecial: 'EnableNoSaveSpecial',
        EnableFixForScrollIssue: 'EnableFixForScrollIssue'
    };
})(ContextResponse || (ContextResponse = {}));
